var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import InputSelect from './InputSelect';
import { FormGroupLabel } from '../FormGroupLabel';
var InputSelectVerticalUncontrolled = /** @class */ (function (_super) {
    __extends(InputSelectVerticalUncontrolled, _super);
    function InputSelectVerticalUncontrolled(props) {
        var _this = _super.call(this, props) || this;
        _this.getSelectedValue = function (value) {
            if (value === null) {
                return _this.state.dataOptions.filter(function (option) { return option.value === 'defaultOptionValue'; })[0];
            }
            else if (value === undefined) {
                return undefined;
            }
            else {
                return _this.state.dataOptions.filter(function (option) { return option.value === value; })[0];
            }
        };
        _this.getDataOptions = function () {
            var _a = _this.props, data = _a.data, optionLabel = _a.optionLabel, optionValue = _a.optionValue, defaultOption = _a.defaultOption;
            var dataOptions = [];
            if (data) {
                if (Array.isArray(data)) {
                    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                        var item = data_1[_i];
                        var dataOption = null;
                        if (item[optionValue] === null) {
                            dataOption = { value: 'defaultOptionValue', label: item[optionLabel] };
                        }
                        else {
                            dataOption = { value: item[optionValue], label: item[optionLabel] };
                        }
                        dataOptions.push(dataOption);
                    }
                }
                else {
                    for (var key in data) {
                        var dataOption = { value: key, label: data[key] };
                        dataOptions.push(dataOption);
                    }
                }
            }
            if (defaultOption) {
                dataOptions.unshift(defaultOption);
            }
            return dataOptions;
        };
        _this.onChange = function (value) {
            var onChange = _this.props.onChange;
            if ((value === null || value === void 0 ? void 0 : value.value) === 'defaultOptionValue') {
                onChange(null);
            }
            else {
                onChange(value === null || value === void 0 ? void 0 : value.value);
            }
        };
        _this.state = {
            dataOptions: _this.getDataOptions(),
        };
        return _this;
    }
    InputSelectVerticalUncontrolled.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({ dataOptions: this.getDataOptions() });
        }
    };
    InputSelectVerticalUncontrolled.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, className = _a.className, isRequired = _a.isRequired, feedback = _a.feedback, isDisabled = _a.isDisabled, isLoading = _a.isLoading, isClearable = _a.isClearable, isSearchable = _a.isSearchable, placeholder = _a.placeholder, name = _a.name, autoFocus = _a.autoFocus, value = _a.value, size = _a.size, isRounded = _a.isRounded, helpText = _a.helpText, saveLSKeyId = _a.saveLSKeyId, id = _a.id, instanceId = _a.instanceId;
        return (React.createElement(FormGroupLabel, { feedback: feedback, isRounded: isRounded, className: className, helpText: helpText, isRequired: isRequired, label: label, id: id },
            React.createElement(InputSelect, { autoFocus: autoFocus, onChange: function (value) {
                    _this.onChange(value);
                }, isDisabled: isDisabled, isLoading: isLoading, isClearable: isClearable, isSearchable: isSearchable, name: name, options: this.state.dataOptions, placeholder: placeholder, value: this.getSelectedValue(value), size: size, isRounded: isRounded, saveLSKeyId: saveLSKeyId, instanceId: instanceId })));
    };
    return InputSelectVerticalUncontrolled;
}(Component));
export default InputSelectVerticalUncontrolled;
//# sourceMappingURL=InputSelectVerticalUncontrolled.js.map